import React, { useState, useEffect } from 'react';
import * as Styles from './CreateKeyModal.styles';
import {
  Modal, TextField, TextArea, Button,
} from 'gatorcomponents';

import useLocale from '@/hooks/useLocale';

import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { vpsOciActions } from '@/redux/modules/productDetail/vpsOci';

const CreateKeyModal = ({
  onClose,
}) => {
  const dispatch = useDispatch();
  const { id: hostingId } = useParams();

  const { loading, success } = useSelector(state => state.vpsOci.sshKeys.create);

  const [sshKeyValues, setSshKeyValues] = useState({ name: '', key: '' });
  const { productDetails: productDetailsLocale } = useLocale();
  const { sshKeys: sshKeysLocale } = productDetailsLocale?.vpsOci;

  const hasError = !sshKeyValues.name || !sshKeyValues.key;

  const handleCloseModal = () => {
    onClose && onClose();
  };

  const handleNameChange = (event) => {
    const { value } = event.target;
    setSshKeyValues(prevValues => ({ ...prevValues, name: value }));
  };

  const handleSshKeyChange = (event) => {
    const { value } = event.target;
    setSshKeyValues(prevValues => ({ ...prevValues, key: value }));
  };

  const handleSubmitSshKey = () => {
    dispatch(vpsOciActions.sshKeys.create.request(hostingId, sshKeyValues));
  };

  useEffect(() => {
    if (success) {
      dispatch(vpsOciActions.sshKeys.create.reset());
      onClose && onClose();
    }
  }, [success, dispatch, onClose]);

  return (
    <Modal
      onClose={handleCloseModal}
      maxWidth={800}
      noContentPadding
      title={sshKeysLocale.management.modal.createKey.title}
      testId="ssh-keys-create-key-modal"
    >
      <Styles.ModalContent>
        <Styles.InputWrapper>
          <Styles.Label htmlFor="ssh-keys-create-key-modal-name-label">
            {sshKeysLocale.management.modal.createKey.inputs.name.label}
          </Styles.Label>
          <TextField
            id="ssh-keys-create-key-modal-name-input"
            type="text"
            label={sshKeysLocale.management.modal.createKey.inputs.name.placeholder}
            value={sshKeyValues.name}
            status="default"
            maxLength={50}
            helpText={sshKeysLocale.management.modal.createKey.inputs.name.helpText}
            onChange={handleNameChange}
            fullWidth
          />
        </Styles.InputWrapper>

        <Styles.TextAreaWrapper>
          <Styles.Label htmlFor="ssh-keys-create-key-modal-key-input">
            {sshKeysLocale.management.modal.createKey.inputs.key.label}
          </Styles.Label>
          <TextArea
            id="ssh-keys-create-key-modal-key-input"
            type="text"
            rows={4}
            label={sshKeysLocale.management.modal.createKey.inputs.key.placeholder}
            value={sshKeyValues.key}
            maxLength={8192}
            status="default"
            onChange={handleSshKeyChange}
            fullWidth
          />
        </Styles.TextAreaWrapper>

        {/* TODO: Será liberado posteriormente, após alinhamento sobre mensagens de erro e validação dos campos
         <AlertV2
          description={sshKeysLocale.management.modal.createKey.alert}
          testId="ssh-keys-create-key-modal-alert"
          variant="info"
          width="full"
          withoutBackground={false}
        /> */}

        <Styles.ModalButtonsWrapper>
          <Button
            label={sshKeysLocale.management.modal.createKey.buttons.cancel}
            variant="tertiary"
            size="large"
            version="v2"
            width="full"
            onClick={onClose}
            testId="ssh-keys-create-key-modal-cancel-button"
          />
          <Button
            label={sshKeysLocale.management.modal.createKey.buttons.create}
            variant="primary"
            negative
            size="large"
            version="v2"
            width="full"
            onClick={loading ? null : handleSubmitSshKey}
            disabled={hasError}
            loading={loading}
            testId="ssh-keys-create-key-modal-create-button"
          />
        </Styles.ModalButtonsWrapper>
      </Styles.ModalContent>
    </Modal>
  );
};

export default CreateKeyModal;
